import { getLanguage } from '@/i18n';

/**
 * LocaleImage - 国际化图片组件，支持：
 *
 * 1. 通过 import.meta.glob 加载本地图片，图片名规范如下：
 *    logo.png        // 默认图片
 *    logo.zh-CN.png  // 国际化图片
 *    logo.en-US.png
 *
 * 2. 直接传语言映射对象：
 *    {
 *      'zh-CN': 'xxx.png',
 *      'en-US': 'xxx.png',
 *      'default': 'xxx.png',
 *    }
 */

export type LocaleImageProps = {
  src: string;
  alt?: string;
  images?:
    | ((src: string) => string)
    | {
        [key: string]: string;
      };
};

export function LocaleImage({ src, alt, images, ...others }: LocaleImageProps) {
  let imgSrc;
  const language = getLanguage();

  // 传入 require.context
  if (typeof images === 'function') {
    const arr = src.split('.');
    arr.splice(-1, 0, language);
    const localeSrc = arr.join('.');

    try {
      imgSrc = images(`./${localeSrc}`);
    } catch (_error: any) {
      console.error(`[LocaleImage] 图片加载失败: ${localeSrc}`, _error);
      try {
        imgSrc = images(`./${src}`);
      } catch (error) {
        console.error(
          `[LocaleImage] 图片加载失败: ${localeSrc} 或 ${src}`,
          error,
        );
      }
    }

    // 传入对象映射
  } else if (typeof images === 'object' && images !== null) {
    imgSrc =
      images[language] || images[language.split('-')[0]] || images.default;
    if (!imgSrc) {
      console.warn(
        `[LocaleImage] 未找到对应语言的图片: ${language}, 使用 src=${src} 回退`,
      );
    }
  }

  return <img src={imgSrc} alt={alt ?? src} {...others} />;
}
